import React from "react";
import { Button, Card, makeStyles, mergeClasses } from "@fluentui/react-components";
import { Dismiss16Regular, Dismiss20Regular } from "@fluentui/react-icons";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  notchContainer: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "auto",
    height: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    backgroundColor: "var(--primaryColorBackground)"
  },
  notchContent: {
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    display: "flex",
    alignItems: "center",
    minWidth: "120px",
    flexDirection: "row",
    paddingTop: "8px",
    paddingBottom: "8px"
  },
  center: {
    justifyContent: "center"
  },
  spaced: {
    justifyContent: "space-between"
  },
  closeButton: {
    // minWidth: "20px",
    // maxWidth: "20px",
    // minHeight: "20px",
    // maxHeight: "20px"
  }
});

export function Notch({ children, center, spaced, onClose }) {
  const styles = useStyles();

  const justifyClass = center ? styles.center : spaced ? styles.spaced : "";

  return (
    <div className={styles.notchContainer}>
      <Card className={mergeClasses(styles.notchContent, justifyClass)}>
        <>
          {children}
          <Button
            className={styles.closeButton}
            appearance="transparent"
            icon={<Dismiss16Regular />}
            onClick={e => onClose(e)}
            size="small"
          />
        </>
      </Card>
    </div>
  );
}

Notch.propTypes = {
  children: PropTypes.node,
  center: PropTypes.bool,
  spaced: PropTypes.bool,
  onClose: PropTypes.func
};
